import { createFilterableCombobox } from '../utils/filterable-combobox';

export const setupDocumentSearch = (): void => {
    /* ── elements ───────────────────────────── */
    const formElement = document.querySelector<HTMLDivElement>('.document-search__form');
    if (!formElement) return;

    const dropdown = document.getElementById('document-brand-dropdown') as HTMLDivElement | null;
    const input = document.getElementById('document-brand-input') as HTMLInputElement | null;
    const hiddenField = document.getElementById('document-brand-name') as HTMLInputElement | null;
    const list = document.getElementById('document-brand-list') as HTMLUListElement | null;
    const barcodeInput = document.getElementById('document-search-barcode') as HTMLInputElement | null;
    const submitBtn = document.getElementById('document-search-submit') as HTMLButtonElement | null;
    const errorContainer = document.getElementById('document-search-error') as HTMLDivElement | null;

    if (!dropdown || !input || !hiddenField || !list  || !barcodeInput || !submitBtn) {
        console.error('Document search: Required elements not found');
        return;
    }

    const items = Array.from(list.querySelectorAll<HTMLLIElement>('.document-search__item'));

    /* ── config ─────────────────────────────── */
    const resultsUrl = formElement.dataset.resultsurl || '';
    const indexCatalogue = formElement.dataset.indexcatalogue || '';
    const language = formElement.dataset.language || '';

    createFilterableCombobox({
        wrapper: dropdown,
        input,
        list,
        hiddenField,
        items,
        classNames: {
            open: 'document-search__dropdown--open',
            itemFocused: 'document-search__item--focused',
            itemHidden: 'document-search__item--hidden',
            empty: 'document-search__empty',
        },
        onEnterWithoutMatch: () => triggerSearch(),
    });

    const clearError = (): void => {
        if (errorContainer && errorContainer.style.display !== 'none') {
            errorContainer.style.display = 'none';
            errorContainer.textContent = '';
        }
    };

    const showValidationError = (): void => {
        if (!errorContainer) return;
        errorContainer.textContent = 'Please enter either a Battery Brand or a Barcode/Serial Number to search.';
        errorContainer.style.display = 'block';
        errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    /* ── search navigation ──────────────────── */
    const triggerSearch = (): void => {
        const brand = hiddenField.value.trim() || input.value.trim();
        const barcode = barcodeInput.value.trim();
        if (!brand && !barcode) {
            showValidationError();
            return;
        }

        clearError();

        const sep = resultsUrl.indexOf('?') >= 0 ? '&' : '?';
        const url = resultsUrl + sep + 'searchQuery=*'
            + (indexCatalogue ? '&indexCatalogue=' + encodeURIComponent(indexCatalogue) : '')
            + (brand ? '&brandName=' + encodeURIComponent(brand) : '')
            + (barcode ? '&barcode=' + encodeURIComponent(barcode) : '')
            + (language ? '&language=' + encodeURIComponent(language) : '');

        window.location.href = url;
    };

    submitBtn.addEventListener('click', triggerSearch);

    hiddenField.addEventListener('input', clearError);
    input.addEventListener('input', clearError);
    barcodeInput.addEventListener('input', clearError);

    barcodeInput.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter') triggerSearch();
    });
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupDocumentSearch);
} else {
  setupDocumentSearch();
}